export default "__VITE_ASSET__BuKWQtuw__"